/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {
  saveJob,
  unFollowJob,
  unFollowRecruiter,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import JobFeedV2 from '@jobseeker/feature-job/components/JobFeed/V2';
import surveyService from '@jobseeker/common-core/services/survey.service';
import {useEffect, useMemo, useState} from 'react';
import {SurveyQuestionType} from '@jobseeker/feature-ads/components/Survey/types';
import {Survey as SurveyType} from '@jobseeker/common-core/services/types';
import {
  getAllParamsFromUrl,
  handleTracking,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';
import moment from 'moment';
import JobsJsonLd from '@jobseeker/feature-job/components/JobItemListingSchema';

import type {AppState} from '@jobseeker/common-core/types';
import type {AdElement} from '@jobseeker/feature-ads/components/AdsBanner/types';
import {JOBAPPLIED, JOBDETAIL, JOBFEED} from '@jobseeker/common-core/constants';

type Fn = () => any;
type JobFeedsListViewProps = {
  routeToJobDetail: (jobSlug: string, jobId: string | number) => void;
  onLoadMore: Fn;
  jobInfoKeyElements: any;
  feedOnly: boolean;
  title: string;
  showThreeDotMenu?: boolean;
  onFilter?: (filterData: any) => void;
  onClearFilter?: () => void;
  onInfiniteScroll?: () => void;
  learnGrow?: AdElement;
  variant?: string;
  injectAsChild?: boolean;
  onFilterChange?: (filterData: object) => void;
  onJobSave?: (data: object) => void;
  showApplied?: boolean;
  catId?: string | number;
  checkJobs?: Map<string, string | undefined>;
  cityJobs?: any;
  preFilters?: {
    page: number;
  } & Record<string, any>;
  extractedParams?: any;
  showIndustry?: boolean;
  showStickyFilter?: boolean;
  showApplyButton?: boolean;
  showCourses?: boolean;
  hideSidebar?: boolean;
};
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const JobFeedsListV2 = ({
  routeToJobDetail,
  onLoadMore,
  jobInfoKeyElements,
  feedOnly,
  title,
  onFilter,
  onInfiniteScroll,
  onClearFilter,
  variant,
  onFilterChange,
  extractedParams,
  preFilters,
  ...props
}: JobFeedsListViewProps) => {
  const dispatch = useDispatch<any>();

  const {isLoggedIn, userId} = useSelector((state: AppState) => state.auth);
  const tags = useSelector((state: AppState) => state.user?.profile?.tags);

  const jobFeedStore = useSelector((state: AppState) => state.job);

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);
  const hideFilter = !tags?.length && page === 'jobfeed' ? true : feedOnly;

  const allparamsfromurl = getAllParamsFromUrl() || {};

  const onJobSave = (jobData: any, unsave: boolean) => {
    if (isLoggedIn) {
      dispatch(
        saveJob({
          ...jobData,
          jobId: jobData.id,
          unsave,
          userId: userId,
        })
      );
    }
    props.onJobSave &&
      props.onJobSave({
        ...jobData,
        jobId: jobData.id,
        unsave,
        userId: userId,
      });
  };

  const onJobActionClick = (jobId: string, action: string) => {
    if (action == 'JOB') {
      dispatch(
        unFollowJob({
          undo: false,
          jobId: jobId,
          userId: userId,
        })
      );
    } else {
      dispatch(
        unFollowRecruiter({
          undo: false,
          recruiterId: 'NO_REC_ID',
          userId: userId,
        })
      );
    }
  };

  const onUndoActionClick = (jobId: string, action: string) => {
    if (action == 'JOB') {
      dispatch(
        unFollowJob({
          undo: true,
          jobId: jobId,
          userId: userId,
        })
      );
    } else {
      dispatch(
        unFollowRecruiter({
          undo: true,
          recruiterId: 'NO_REC_ID',
          userId: userId,
        })
      );
    }
  };

  const [showSurvey, setShowSurvey] = useState(false);
  const [surveyQuestions, setSurveyQuestions] = useState<SurveyQuestionType[]>(
    []
  );
  const [currQuestion, setCurrQuestion] = useState<SurveyQuestionType>(
    surveyQuestions[0]
  );

  const [showMarketingSurvey, setShowMarketingSurvey] = useState(false);
  const [marketingSurveyQuestions, setMarketingSurveyQuestions] = useState<
    SurveyQuestionType[]
  >([]);
  const [marketingCurrQuestion, setMarketingCurrQuestion] =
    useState<SurveyQuestionType>(marketingSurveyQuestions[0]);
  const [marketingSurveyPosition, setMarketingSurveyPosition] = useState('');
  const fetchSurveys = async () => {
    const surveys: SurveyType[] = await surveyService.getSurvey('JF');
    if (surveys?.length) {
      const jobFeedSurvey = surveys.find(
        survey => survey?.type === 'RelevantJob'
      );
      if (jobFeedSurvey) {
        setShowSurvey(true);
        handleTracking('jsViewRelevantJobSurvey', {
          event_category: 'Job_recommedation_survey',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: page,
          Date: moment().format('DD/MM/YYYY'),
        });
        setSurveyQuestions(jobFeedSurvey?.questions);
        setCurrQuestion(jobFeedSurvey?.questions[0]);
      }
    }
  };

  const fetchMarketingSurveys = async () => {
    const surveys: SurveyType[] = await surveyService.getSurvey('JOBFEED');
    if (surveys?.length) {
      const jobFeedSurvey = surveys.find(
        survey => survey?.type === 'Marketing'
      );
      if (jobFeedSurvey) {
        setShowMarketingSurvey(true);
        // Fire UBA surveyView event when survey is displayed
        if (jobFeedSurvey.type === 'Marketing') {
          TrackEventUBA('surveyView', 'view', {
            pageName: page === 'jobfeed' ? 'jobfeed' : 'similarJobs',
            sessionUsername: sessionStorage.getItem('userId') || '',
            surveyName: 'Marketing PR Survey MBA Cohort',
            surveyId: jobFeedSurvey?.id,
          });
        }
        setMarketingSurveyQuestions(jobFeedSurvey?.questions);
        setMarketingCurrQuestion(jobFeedSurvey?.questions[0]);
        if (allparamsfromurl.ref === 'survey_marketing_pr_mbas') {
          setMarketingSurveyPosition('0'); // Show at top
        } else {
          setMarketingSurveyPosition(jobFeedSurvey?.position);
        }
      }
    }
  };

  const marketingSurveyPositions = useMemo(() => {
    if (!marketingSurveyPosition || marketingSurveyPosition?.trim() === '')
      return [];
    return marketingSurveyPosition
      .split(',')
      .map(pos => {
        const position = parseInt(pos.trim(), 10);
        return position - 1;
      })
      .filter(pos => !isNaN(pos));
  }, [marketingSurveyPosition]);

  useEffect(() => {
    if (page === 'jobfeed') {
      fetchSurveys();
    }
    if ([JOBFEED, JOBAPPLIED, JOBDETAIL].includes(page) && isAppIimjobs) {
      fetchMarketingSurveys();
    }
  }, [page]);

  // const JobFeedComponent =
  //   process.env.NEXT_PUBLIC_APP_NAME === 'hirist' ? JobFeedHirist : JobFeedV2;

  // console.log(
  //   process.env.NEXT_PUBLIC_APP_NAME,
  //   'JobFeedHirist',
  //   JobFeedComponent
  // );

  return (
    <>
      {!props?.injectAsChild && (
        <JobsJsonLd
          name={`${title}`}
          jobs={[
            ...jobFeedStore?.jobfeed,
            ...(page === 'location_based' &&
            props?.cityJobs?.jobs?.length > 0 &&
            jobFeedStore?.jobfeed?.length < 20 &&
            !isAppIimjobs
              ? props?.cityJobs?.jobs
              : []),
          ]}
        />
      )}
      <JobFeedV2
        onLoadMore={onLoadMore}
        onUndoActionClick={onUndoActionClick}
        onJobActionClick={onJobActionClick}
        onFilter={onFilter}
        onClearFilter={onClearFilter}
        feedOnly={feedOnly}
        title={title}
        variant={isLoggedIn ? 'userFeed' : ''}
        jobFeedStore={jobFeedStore}
        jobInfoKeyElements={jobInfoKeyElements}
        routeToJobDetail={routeToJobDetail}
        showSurvey={showSurvey}
        surveyQuestions={surveyQuestions}
        setShowSurvey={setShowSurvey}
        currQuestion={currQuestion}
        setCurrentQuestion={setCurrQuestion}
        showMarketingSurvey={showMarketingSurvey}
        marketingSurveyQuestions={marketingSurveyQuestions}
        setShowMarketingSurvey={setShowMarketingSurvey}
        marketingCurrQuestion={marketingCurrQuestion}
        setMarketingCurrQuestion={setMarketingCurrQuestion}
        marketingSurveyPositions={marketingSurveyPositions}
        page={page}
        onInfiniteScroll={onInfiniteScroll}
        onFilterChange={onFilterChange}
        {...props}
        onJobSave={onJobSave}
        showFilter={!hideFilter}
        showApplied={props.showApplied || false}
        preFilters={preFilters}
        extractedParams={extractedParams}
      />
    </>
  );
};

export default JobFeedsListV2;
